(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gwp-claim]');
    if (!btn) return;

    var banner = btn.closest('.gwp-banner');
    if (!banner) return;

    var variantId = banner.dataset.gwpVariantId;
    var handle = banner.dataset.gwpHandle;
    if (!variantId) return;

    btn.disabled = true;

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: Number(variantId),
          quantity: 1,
          properties: { ['_gwp_' + handle]: 'true' },
        }],
        sections: sectionIds.join(','),
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var evt = new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                data: {
                  source: 'gwp',
                  sections: response.sections || {},
                },
              },
            });
            document.dispatchEvent(evt);
          });
      })
      .catch(function () {
        btn.disabled = false;
      });
  });
})();
